import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { cn } from 'components/lib/utils';
import Typography from 'components/Typography/Typography';

interface UploadFileWrapperProps {
  className?: string;
  isRequired?: boolean;
  title?: string;
  description?: string;
  children?: React.ReactNode;
}

export function UploadFileWrapper({
  className,
  isRequired,
  title,
  description,
  children
}: UploadFileWrapperProps) {
  return (
    <div
      className={cn(
        'flex justify-between items-center w-full py-8 px-11 bg-base-secondary rounded-md border-dashed border border-base-mutedForeground',
        className
      )}
    >
      <div>
        <Typography className="flex font-medium text-p-s mb-1.5">
          {isRequired && (
            <div className="mr-1 mt-1">
              <FontAwesomeIcon
                icon="fa-regular fa-asterisk"
                className="h-2 w-2 text-[8px]"
              />
            </div>
          )}
          {title}
        </Typography>
        <Typography className="text-p-xs text-base-sidebarRing whitespace-pre-line">
          {description}
        </Typography>
      </div>
      {children}
    </div>
  );
}
